import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = props => {
  return props.auth.payload ? props.children : <Navigate to={'/auth'}/>;
}

export default PrivateRoute;